import React from 'react';
import Main from '../../component/layout/mainSection';
import Services from '../../component/layout/services';
import Projects from '../../component/layout/projects';
import Clients from '../../component/layout/client';
import Footer from '../../component/common/footer';
import Meeting from '../../component/layout/meeting';
import SEO from '../../component/util/SEO';

function Home() {
  const style = {
    backgroundColor: '#171818',
    paddingTop: '50px',
  };

  return (
    <>
      <SEO
        title="Bringit Go - Web Development, UI/UX Design, Cloud, Mobile & Blockchain Services"
        description="BringIt Go is a technology company helping businesses build websites, SaaS applications, UI/UX designs, cloud infrastructure, mobile apps, and blockchain products."
        canonical="https://www.bringitgo.tech/"
        keywords="web development company, UI UX design services, cloud infrastructure services, mobile app development, blockchain development, SaaS development"
      />
      <main>
        <Main />
        <section style={style} aria-label="BringIt Go services, projects and clients">
          <Services />
          <Projects />
          <Clients />
          <Meeting />
        </section>
      </main>
    </>
  );
}

export default Home;
